import React, { memo } from 'react'
import cx from 'classnames'
import { endsWith } from 'libraries/lodash'
import { ContentReference, SectionContent } from 'components/legislation-reference/Item'

const ContentParagraph = memo(({ attributes: { ref: reference, id }, childNodes, highlighted }) => {
  const marked = !!reference && highlighted.reduce((a, h) => a || endsWith(id, h), false)

  return (
    <div className={cx({ 'fc-p': true, mark: marked })}>
      <ContentReference reference={reference} />
      {childNodes.map((node, index) => <SectionContent key={index} {...node} />)}
    </div>
  )
})

export default ContentParagraph
